/* ============================================================
   PREMIUM SEARCH  —  premium-search.js
   Shopify Predictive Search API. Live AJAX results, keyboard
   navigation (arrows + enter + esc), voice search, recent search
   history (localStorage), quick add-to-cart, wishlist toggle.
   ============================================================ */
(function () {
  'use strict';

  var RECENT_KEY = 'ps_recent_searches';
  var RECENT_MAX = 6;

  function initRoot(root) {
    if (!root || root.__psInit) return;
    root.__psInit = true;

    var sectionId = root.getAttribute('data-section-id');
    var cfg = (window.PremiumSearchConfig && window.PremiumSearchConfig[sectionId]) || {};
    cfg.predictiveUrl = cfg.predictiveUrl || '/search/suggest.json';
    cfg.searchUrl = cfg.searchUrl || '/search';
    cfg.cartAddUrl = cfg.cartAddUrl || '/cart/add.js';
    cfg.resources = cfg.resources || { limit: 6, types: 'product,collection,page,article' };
    cfg.text = cfg.text || {};

    var els = {
      backdrop:  root.querySelector('[data-ps-backdrop]'),
      modal:     root.querySelector('[data-ps-modal]'),
      input:     root.querySelector('[data-ps-input]'),
      clear:     root.querySelector('[data-ps-clear]'),
      close:     root.querySelector('[data-ps-close]'),
      voice:     root.querySelector('[data-ps-voice]'),
      defaultV:  root.querySelector('[data-ps-default]'),
      results:   root.querySelector('[data-ps-results]'),
      loading:   root.querySelector('[data-ps-loading]'),
      foot:      root.querySelector('[data-ps-foot]'),
      footTerm:  root.querySelector('[data-ps-foot-term]'),
      searchAll: root.querySelector('[data-ps-search-all]'),
      recentBlock: root.querySelector('[data-ps-recent-block]'),
      recent:    root.querySelector('[data-ps-recent]'),
      clearRecent: root.querySelector('[data-ps-clear-recent]'),
      suggestBlock: root.querySelector('[data-ps-suggest-block]'),
      suggestions: root.querySelector('[data-ps-suggestions]'),
      productsBlock: root.querySelector('[data-ps-products-block]'),
      products:  root.querySelector('[data-ps-products]'),
      viewAll:   root.querySelector('[data-ps-view-all]'),
      collBlock: root.querySelector('[data-ps-collections-block]'),
      collections: root.querySelector('[data-ps-collections]'),
      pagesBlock: root.querySelector('[data-ps-pages-block]'),
      pages:     root.querySelector('[data-ps-pages]'),
      artBlock:  root.querySelector('[data-ps-articles-block]'),
      articles:  root.querySelector('[data-ps-articles]'),
      empty:     root.querySelector('[data-ps-empty]')
    };
    var template = root.querySelector('[data-ps-card-template]') ||
                   document.querySelector('[data-ps-card-template]');

    var lastFocus = null;
    var debounceTimer = null;
    var activeIndex = -1;

    /* -------------------- OPEN / CLOSE -------------------- */
    function open() {
      lastFocus = document.activeElement;
      root.hidden = false;
      root.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      requestAnimationFrame(function () {
        root.classList.add('is-open');
        setTimeout(function () { els.input && els.input.focus(); }, 60);
      });
      renderRecent();
    }
    function close() {
      root.classList.remove('is-open');
      root.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      setTimeout(function () {
        root.hidden = true;
        if (lastFocus && lastFocus.focus) lastFocus.focus();
      }, 320);
    }

    if (els.backdrop) els.backdrop.addEventListener('click', close);
    if (els.close) els.close.addEventListener('click', close);

    /* -------------------- RECENT SEARCHES -------------------- */
    function getRecent() {
      try { return JSON.parse(localStorage.getItem(RECENT_KEY)) || []; }
      catch (e) { return []; }
    }
    function saveRecent(term) {
      term = (term || '').trim();
      if (!term) return;
      var list = getRecent().filter(function (t) { return t.toLowerCase() !== term.toLowerCase(); });
      list.unshift(term);
      list = list.slice(0, RECENT_MAX);
      try { localStorage.setItem(RECENT_KEY, JSON.stringify(list)); } catch (e) {}
    }
    function renderRecent() {
      var list = getRecent();
      if (!els.recentBlock) return;
      if (!list.length) { els.recentBlock.hidden = true; return; }
      els.recentBlock.hidden = false;
      els.recent.innerHTML = '';
      list.forEach(function (term) {
        var chip = document.createElement('span');
        chip.className = 'ps-chip ps-chip--recent';
        var label = document.createElement('button');
        label.type = 'button';
        label.className = 'ps-chip__label';
        label.style.cssText = 'border:none;background:none;cursor:pointer;color:inherit;font:inherit;';
        label.textContent = term;
        label.addEventListener('click', function () { runSuggest(term); });
        var rm = document.createElement('button');
        rm.type = 'button';
        rm.className = 'ps-chip__remove';
        rm.setAttribute('aria-label', 'Remove ' + term);
        rm.innerHTML = '<svg viewBox="0 0 24 24" width="12" height="12" fill="none"><path d="M6 6l12 12M18 6 6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';
        rm.addEventListener('click', function (e) {
          e.stopPropagation();
          var next = getRecent().filter(function (t) { return t !== term; });
          try { localStorage.setItem(RECENT_KEY, JSON.stringify(next)); } catch (er) {}
          renderRecent();
        });
        chip.appendChild(label);
        chip.appendChild(rm);
        els.recent.appendChild(chip);
      });
    }
    if (els.clearRecent) els.clearRecent.addEventListener('click', function () {
      try { localStorage.removeItem(RECENT_KEY); } catch (e) {}
      renderRecent();
    });

    /* -------------------- SUGGESTION CHIPS -------------------- */
    root.querySelectorAll('[data-ps-suggest]').forEach(function (btn) {
      btn.addEventListener('click', function () { runSuggest(btn.getAttribute('data-ps-suggest')); });
    });
    function runSuggest(term) {
      els.input.value = term;
      els.input.focus();
      toggleClear();
      doSearch(term);
    }

    /* -------------------- INPUT -------------------- */
    function toggleClear() {
      var has = els.input.value.trim().length > 0;
      if (els.clear) els.clear.hidden = !has;
      els.input.setAttribute('aria-expanded', has ? 'true' : 'false');
    }
    els.input.addEventListener('input', function () {
      toggleClear();
      var q = els.input.value.trim();
      clearTimeout(debounceTimer);
      if (!q) { showDefault(); return; }
      debounceTimer = setTimeout(function () { doSearch(q); }, 220);
    });
    if (els.clear) els.clear.addEventListener('click', function () {
      els.input.value = '';
      toggleClear();
      showDefault();
      els.input.focus();
    });

    function showDefault() {
      els.defaultV.hidden = false;
      els.results.hidden = true;
      els.foot.hidden = true;
      activeIndex = -1;
      renderRecent();
    }
    function showResultsPane() {
      els.defaultV.hidden = true;
      els.results.hidden = false;
    }

    /* -------------------- SEARCH -------------------- */
    function highlight(text, q) {
      if (!q) return text;
      try {
        var re = new RegExp('(' + q.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + ')', 'ig');
        return text.replace(re, '<mark>$1</mark>');
      } catch (e) { return text; }
    }

    function stars(rating) {
      var r = Math.round((parseFloat(rating) || 0) * 2) / 2;
      var full = Math.floor(r), half = r - full === 0.5, out = '';
      for (var i = 0; i < full; i++) out += '★';
      if (half) out += '⯨';
      while (out.length < 5) out += '☆';
      return out;
    }

    function doSearch(q) {
      showResultsPane();
      els.loading.hidden = false;
      els.empty.hidden = true;

      fetch(cfg.predictiveUrl
        + '?q=' + encodeURIComponent(q)
        + '&resources[type]=' + encodeURIComponent(cfg.resources.types)
        + '&resources[limit]=' + encodeURIComponent(cfg.resources.limit),
        { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          els.loading.hidden = true;
          renderResults(data.resources && data.resources.results ? data.resources.results : {}, q);
        })
        .catch(function () {
          els.loading.hidden = true;
          renderResults({}, q);
        });
    }

    function renderResults(res, q) {
      var products = res.products || [];
      var collections = res.collections || [];
      var pages = res.pages || [];
      var articles = res.articles || [];
      var queries = res.queries || [];

      activeIndex = -1;

      // Foot
      els.foot.hidden = false;
      els.footTerm.textContent = '“' + q + '”';
      els.searchAll.setAttribute('href', cfg.searchUrl + '?q=' + encodeURIComponent(q) + '&type=product');

      // Suggestions (query completions)
      if (queries.length) {
        els.suggestBlock.hidden = false;
        els.suggestions.innerHTML = '';
        queries.slice(0, 5).forEach(function (item) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'ps-suggest';
          b.setAttribute('role', 'option');
          b.innerHTML = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none"><circle cx="11" cy="11" r="7" stroke="currentColor" stroke-width="1.5"/><path d="m20 20-3.5-3.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg><span>' + highlight(item.text || item.styled_text || '', q) + '</span>';
          b.addEventListener('click', function () { runSuggest(item.text); });
          els.suggestions.appendChild(b);
        });
      } else {
        els.suggestBlock.hidden = true;
      }

      // Products
      if (products.length) {
        els.productsBlock.hidden = false;
        els.products.innerHTML = '';
        products.forEach(function (p) { els.products.appendChild(buildCard(p, q)); });
        if (els.viewAll) {
          els.viewAll.hidden = false;
          els.viewAll.setAttribute('href', cfg.searchUrl + '?q=' + encodeURIComponent(q) + '&type=product');
        }
      } else {
        els.productsBlock.hidden = true;
      }

      // Collections
      renderLinks(els.collBlock, els.collections, collections, 'collection');
      // Pages
      renderLinks(els.pagesBlock, els.pages, pages, 'page');
      // Articles
      renderLinks(els.artBlock, els.articles, articles, 'article');

      // Empty
      var nothing = !products.length && !collections.length && !pages.length && !articles.length && !queries.length;
      els.empty.hidden = !nothing;
    }

    function renderLinks(block, container, items, kind) {
      if (!block || !container) return;
      if (!items || !items.length) { block.hidden = true; return; }
      block.hidden = false;
      container.innerHTML = '';
      items.forEach(function (item) {
        var a = document.createElement('a');
        a.className = 'ps-link';
        a.setAttribute('role', 'option');
        a.href = item.url;
        var thumb = '';
        if (item.featured_image && item.featured_image.url) {
          thumb = '<img class="ps-link__thumb" src="' + item.featured_image.url + '" alt="" loading="lazy">';
        } else if (item.image) {
          thumb = '<img class="ps-link__thumb" src="' + item.image + '" alt="" loading="lazy">';
        } else {
          var ico = kind === 'collection'
            ? '<svg class="ps-link__ico" viewBox="0 0 24 24" width="20" height="20" fill="none"><rect x="3" y="3" width="7" height="7" rx="1" stroke="currentColor" stroke-width="1.5"/><rect x="14" y="3" width="7" height="7" rx="1" stroke="currentColor" stroke-width="1.5"/><rect x="3" y="14" width="7" height="7" rx="1" stroke="currentColor" stroke-width="1.5"/><rect x="14" y="14" width="7" height="7" rx="1" stroke="currentColor" stroke-width="1.5"/></svg>'
            : kind === 'article'
            ? '<svg class="ps-link__ico" viewBox="0 0 24 24" width="20" height="20" fill="none"><path d="M6 3h9l3 3v15H6z" stroke="currentColor" stroke-width="1.5"/><path d="M9 9h6M9 13h6M9 17h4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>'
            : '<svg class="ps-link__ico" viewBox="0 0 24 24" width="20" height="20" fill="none"><path d="M4 5h16M4 12h16M4 19h10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>';
          thumb = ico;
        }
        a.innerHTML = thumb + '<span>' + (item.title || '') + '</span>';
        container.appendChild(a);
      });
    }

    function buildCard(p, q) {
      var frag = template.content.cloneNode(true);
      var card = frag.querySelector('[data-result-card]');
      card.setAttribute('href', p.url);
      card.dataset.handle = p.handle || '';

      var variant = (p.variants && p.variants[0]) || null;
      var available = p.available !== false;

      var img = card.querySelector('[data-card-image]');
      var src = (p.featured_image && (p.featured_image.url || p.featured_image)) || p.image;
      if (src) { img.src = src; img.alt = p.title; }
      else { img.remove(); }

      card.querySelector('[data-card-title]').innerHTML = highlight(p.title, q);

      var priceEl = card.querySelector('[data-card-price]');
      if (p.price != null) {
        priceEl.textContent = formatFromPredictive(p.price);
      } else if (variant && variant.price != null) {
        priceEl.textContent = formatFromPredictive(variant.price);
      }
      if (p.compare_at_price && p.compare_at_price_max && p.compare_at_price_max > p.price) {
        var cmp = card.querySelector('[data-card-compare]');
        cmp.textContent = formatFromPredictive(p.compare_at_price_max);
        cmp.hidden = false;
      }

      // Availability
      var av = card.querySelector('[data-card-avail]');
      av.textContent = available ? (cfg.text.inStock || 'In Stock') : (cfg.text.soldOut || 'Sold Out');
      if (!available) av.classList.add('is-out');

      var badge = card.querySelector('[data-card-badge]');
      if (!available && badge) { badge.textContent = cfg.text.soldOut || 'Sold Out'; badge.hidden = false; }

      // Quick add
      var addBtn = card.querySelector('[data-card-add]');
      if (addBtn) {
        if (!available || !variant) { addBtn.disabled = true; addBtn.style.opacity = '.5'; }
        addBtn.addEventListener('click', function (e) {
          e.preventDefault(); e.stopPropagation();
          var vid = variant ? (variant.id) : null;
          if (!vid) return;
          addBtn.disabled = true;
          fetch(cfg.cartAddUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: [{ id: vid, quantity: 1 }] })
          }).then(function () {
            refreshCart();
            addBtn.disabled = false;
          }).catch(function () { addBtn.disabled = false; });
        });
      }

      // Wishlist
      var wishBtn = card.querySelector('[data-card-wish]');
      if (wishBtn) {
        wishBtn.addEventListener('click', function (e) {
          e.preventDefault(); e.stopPropagation();
          toggleWishlist(p, wishBtn);
        });
      }

      return card;
    }

    function formatFromPredictive(val) {
      // Predictive API returns already-formatted price strings in most themes
      if (typeof val === 'string') return val;
      // number in cents fallback
      var n = (val / 100);
      try { return n.toLocaleString(undefined, { style: 'currency', currency: window.Shopify && Shopify.currency ? Shopify.currency.active : 'INR' }); }
      catch (e) { return n.toFixed(2); }
    }

    function refreshCart() {
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          document.querySelectorAll('.cart-badge, [data-cart-count], .cart-count-bubble')
            .forEach(function (el) { el.textContent = cart.item_count; });
          try { document.dispatchEvent(new CustomEvent('cart:refresh')); } catch (e) {}
        });
    }

    function toggleWishlist(p, btn) {
      var key = cfg.wishlistKey || 'wishlist';
      var list;
      try { list = JSON.parse(localStorage.getItem(key)) || []; } catch (e) { list = []; }
      if (!Array.isArray(list)) list = [];
      var entry = { id: String(p.id), handle: p.handle };
      var exists = list.some(function (x) {
        var xid = (x && (x.id || x)) ; return String(xid) === String(p.id) || (x && x.handle === p.handle);
      });
      if (exists) {
        list = list.filter(function (x) {
          var xid = (x && (x.id || x)); return !(String(xid) === String(p.id) || (x && x.handle === p.handle));
        });
        btn.classList.remove('is-active');
      } else {
        list.push(entry);
        btn.classList.add('is-active');
      }
      try { localStorage.setItem(key, JSON.stringify(list)); } catch (e) {}
      try {
        window.dispatchEvent(new CustomEvent('wishlist:changed', { detail: { entry: entry } }));
        document.dispatchEvent(new CustomEvent('wishlist:added', { detail: { entry: entry } }));
      } catch (e) {}
    }

    /* -------------------- SAVE ON SUBMIT -------------------- */
    els.input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        var opts = currentOptions();
        if (activeIndex >= 0 && opts[activeIndex]) {
          e.preventDefault();
          opts[activeIndex].click();
          return;
        }
        var q = els.input.value.trim();
        if (q) {
          saveRecent(q);
          window.location.assign(cfg.searchUrl + '?q=' + encodeURIComponent(q) + '&type=product');
        }
      }
    });
    if (els.searchAll) els.searchAll.addEventListener('click', function () {
      saveRecent(els.input.value.trim());
    });

    /* -------------------- KEYBOARD NAV -------------------- */
    function currentOptions() {
      if (els.results.hidden) return [];
      return Array.prototype.slice.call(
        els.results.querySelectorAll('.ps-suggest, .ps-card, .ps-link')
      );
    }
    function setActive(idx) {
      var opts = currentOptions();
      opts.forEach(function (o) { o.classList.remove('is-active'); });
      if (idx < 0 || idx >= opts.length) { activeIndex = -1; return; }
      activeIndex = idx;
      var el = opts[idx];
      el.classList.add('is-active');
      el.scrollIntoView({ block: 'nearest' });
    }
    root.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { e.preventDefault(); close(); return; }
      if (els.results.hidden) return;
      var opts = currentOptions();
      if (!opts.length) return;
      if (e.key === 'ArrowDown') { e.preventDefault(); setActive((activeIndex + 1) % opts.length); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); setActive((activeIndex - 1 + opts.length) % opts.length); }
    });

    /* -------------------- VOICE -------------------- */
    if (els.voice) {
      var SR = window.SpeechRecognition || window.webkitSpeechRecognition;
      if (!SR) {
        els.voice.setAttribute('title', 'Voice search not supported in this browser');
      } else {
        var recog = new SR();
        recog.lang = document.documentElement.lang || 'en-US';
        recog.interimResults = false;
        recog.maxAlternatives = 1;
        els.voice.addEventListener('click', function () {
          try {
            els.voice.classList.add('is-listening');
            recog.start();
          } catch (e) { els.voice.classList.remove('is-listening'); }
        });
        recog.addEventListener('result', function (e) {
          var transcript = e.results[0][0].transcript;
          els.input.value = transcript;
          toggleClear();
          doSearch(transcript.trim());
        });
        recog.addEventListener('end', function () { els.voice.classList.remove('is-listening'); });
        recog.addEventListener('error', function () { els.voice.classList.remove('is-listening'); });
      }
    }

    /* -------------------- TRIGGERS -------------------- */
    function bindTriggers() {
      // Explicit opt-in triggers
      document.querySelectorAll('[data-open-premium-search]').forEach(function (t) {
        if (t.__psBound) return; t.__psBound = true;
        t.addEventListener('click', function (e) { e.preventDefault(); open(); });
      });
      // Header search links/buttons pointing at /search
      document.querySelectorAll('a[href$="/search"], a[href*="/search?"], a[href="' + cfg.searchUrl + '"]').forEach(function (a) {
        if (a.__psBound || a.closest('[data-premium-search]')) return;
        a.__psBound = true;
        a.addEventListener('click', function (e) { e.preventDefault(); open(); });
      });
    }
    bindTriggers();

    // Expose a global opener
    window.openPremiumSearch = open;

    // Keyboard shortcut: "/" or Cmd/Ctrl+K
    document.addEventListener('keydown', function (e) {
      var typing = /^(input|textarea|select)$/i.test((e.target.tagName || '')) || e.target.isContentEditable;
      if ((e.key === '/' && !typing) || ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'k')) {
        e.preventDefault();
        if (root.hidden) open();
      }
    });
  }

  function boot() {
    document.querySelectorAll('[data-premium-search]').forEach(initRoot);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-premium-search]');
    if (root) { root.__psInit = false; initRoot(root); }
  });
})();
